<template>
  <div class="success-purchase">
    <a class="close-x" @click="closeSuccessMsg">
      <img class="close-icon" src="@/assets/images/close_icon.svg" alt="">
    </a>
    <section class="content">
      <h1 class="title">
        {{ $t('ADD_TO_MY_AREA_SUCCESS') }}
      </h1>
      <v-check-animation/>
    </section>
    <footer class="success-purchase-footer">
      <a :href="collectionEntryUrl" target="_blank">
      <button class="common-button next-button">
       {{ $t('SHARE_WITH_STUDENTS') }}
      </button>
      </a>
      <a @click="closeSuccessMsg">
      <button class="common-button back-button">
        {{ $t('BACK_TO_LIBRARY') }}
      </button>
      </a>
    </footer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import VCheckAnimation from '@/components/v-check-animation.vue'
import { getClasseUnitUrl } from '@/utilityFunctions'

export default {
  name: 'success-response',
  components: { VCheckAnimation },
  computed: {
    ...mapState({
      librarySlug: state => state.base.library.slug
    }),
    collectionEntryUrl () {
      return getClasseUnitUrl(this.$route.params.unitId) + '&openSharePop=true'
    }
  },

  methods: {
    closeSuccessMsg (e) {
      e.preventDefault()
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>

</style>
